import { FC } from 'react';
import cx from 'classnames';
import { transitionAnimationClassNames } from '../../../../utils/transitionAnimationClassNames';
import Spinner from '../../Spinner/Spinner';
import { BlockForDeactivatedUser } from '../../BlockForDeactivatedUser/BlockForDeactivatedUser';

type TPostCommentButtonProps = {
  isLoading?: boolean;
  isValid?: boolean;
};

const PostCommentButton: FC<TPostCommentButtonProps> = ({ isLoading, isValid }) => (
  <BlockForDeactivatedUser>
    <button
      disabled={!isValid}
      type="submit"
      className={cx('absolute bottom-2 right-2 px-5 py-px rounded-md capitalize', transitionAnimationClassNames, {
        'bg-gray-100 text-black-700': !isValid,
        'bg-gray-700 text-white-100 hover:bg-orange-500 hover:shadow-hoverShadow': isValid,
        'bg-orange-500 hover:!shadow-none': isLoading,
      })}
    >
      {isLoading && (
        <div className="absolute left-1/2 -translate-x-1/2">
          <Spinner size={5} color="white" />
        </div>
      )}
      <div
        className={cx({
          invisible: isLoading,
          visible: !isLoading,
        })}
      >
        post
      </div>
    </button>
  </BlockForDeactivatedUser>
);
export default PostCommentButton;
